// extracted by mini-css-extract-plugin
export default {"loader":"Loader_loader__+lRPl","spin":"Loader_spin__E4RJ0","small":"Loader_small__gii2m"};